import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/ui/AgentChip.tsx
// Small pill showing agent name with agent-specific accent color.
// Used inside AgentMessage to show which specialists were consulted.
import { agentVariant, Badge } from "./Badge";
import { agentIcon, agentLabel } from "../../lib/agentConfig";
export function AgentChip({ agentId, className = "" }) {
    const variant = agentVariant(agentId);
    const icon = agentIcon(agentId.toLowerCase());
    // Show what the agent DOES (e.g. "Tax Analysis"), not its internal
    // codename (e.g. "Vault"). Single source of truth: agentConfig.
    const name = agentLabel(agentId.toLowerCase());
    return (_jsxs(Badge, { variant: variant, size: "xs", className: className, children: [_jsx("span", { children: icon }), _jsx("span", { children: name })] }));
}
